import { Upload, FileCheck, ShieldCheck, ClipboardCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import FeatureCard from './marketing/FeatureCard';

export default function Features() {
  const { t } = useLanguage();

  const features = [
    {
      icon: <Upload />,
      title: t('landing.features.import.title'),
      description: t('landing.features.import.description'),
    },
    {
      icon: <FileCheck />,
      title: t('landing.features.reporting.title'),
      description: t('landing.features.reporting.description'),
    },
    {
      icon: <ShieldCheck />,
      title: t('landing.features.readiness.title'),
      description: t('landing.features.readiness.description'),
    },
    {
      icon: <ClipboardCheck />,
      title: t('landing.features.evaluation.title'),
      description: t('landing.features.evaluation.description'),
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-slate-50/50" id="features">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {t('landing.features.title')}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            {t('landing.features.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {features.map((feature) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
